import {
    addType,
    editType,
    deleteType
} from "./actions";

export default {
    "label": "Types",
    "key": "Types",
    "location": "Matrices/SignatoryMatrix/Types/",
    "headers": [{
        "headerName": "Type",
        "field": "Type",
        "flex": 1
    }, {
            "headerName": "Threshold",
            "field": "Threshold",
            "flex": 1
        }],
    "actions": [{
        "label": "Add Type",
        "action": addType
    }],
    "rowActions": [{
        "label": "Edit Type",
        "action": editType
    }, {
        "label": "Delete Type",
        "action": deleteType
    }]
}
